// extracted by mini-css-extract-plugin
export default {"box":"selectdropdown_box__44tDh","select":"selectdropdown_select__ABI9d","fieldSm":"selectdropdown_fieldSm__0LABc","label":"selectdropdown_label__ks-fZ"};